module.exports = __webpack_public_path__ + "img/19.8b6451fc.jpg";